import React from "react";
import { shallowEqual } from "react-redux";
import { FINANCE_CALCULATOR } from "../../../../../../../../common-deprecated/constants";
import * as Styles from "./styles/BasketCtasStyles";
import type { FinanceOptionType } from "../../../../../../../../common-deprecated/types/CommonTypes";
import { useBnbSelector } from "../../../../../redux/store";
import { NavStep } from "../../../../../../shared-logic/utils/Navigation";
import FinanceInsuranceCalculatorLink from "../../../../../utils/FinanceInsuranceCalculatorLink";

import { BnbLabel } from "../../../../../utils/labels";
import Preloader, * as PreloaderStyles from "../../../../../../../../common-deprecated/styles/v2/toyota/custom/Preloader";
import useCtaList from "../../../../../hooks/shared/actions/useCtaList";
import { enabledServicesSelector } from "../../../../../utils/selectorUtils";
import { useFinanceInsuranceNavigation } from "../../../../../hooks/shared/useFinanceInsurance";
import ButtonCta, { CtaIcon } from "../../../../../../../../common-deprecated/components/aem/toyota/ButtonCta";
import { ConsumerBasketCtas } from "./ConsumerBasketCtas";

type PropsType = {
    step: NavStep;
    financeOption: FinanceOptionType;
};

const BasketCtas = ({ step, financeOption }: PropsType): JSX.Element => {
    const ctas = useCtaList("summaryBasketCta");
    const primaryCta = ctas[0];

    const config = useBnbSelector((state) => state.save);
    const bnbSettings = useBnbSelector((state) => state.bnbSettings);

    const { showFinance } = useBnbSelector(enabledServicesSelector, shallowEqual);

    const { saving: tyCodeSaving, error: tyCodeSavingFailed } = config;
    const financeQuoteId = useBnbSelector((state) => state.finance.quotes.finance);
    const renderFinanceCalculatorAsPrimary =
        bnbSettings.showFinanceCalculatorAsPrimaryCTA &&
        primaryCta?.type === "go-to-buy" &&
        financeOption === "monthly" &&
        !financeQuoteId;

    const { onClick: onFinanceClick, financeLabelKey } = useFinanceInsuranceNavigation(step);

    return (
        <>
            {showFinance &&
                (financeOption === "monthly" ||
                    bnbSettings?.showFinanceInsuranceInPage ||
                    bnbSettings?.enableFinanceCompare) &&
                (!renderFinanceCalculatorAsPrimary || step !== NavStep.Summary) && (
                    // This is hidden by CSS to prevent the removal of the eventListener that closes the finance calculator
                    <Styles.ButtonGroup display={renderFinanceCalculatorAsPrimary ? "none" : "block"}>
                        {!bnbSettings?.showFinanceInsuranceInPage && !bnbSettings?.enableFinanceCompare ? (
                            <FinanceInsuranceCalculatorLink
                                type={FINANCE_CALCULATOR}
                                customButton={(props) => (
                                    <ButtonCta onClick={props.onClick} iconVariant={CtaIcon.Card}>
                                        <BnbLabel label={props.label} />
                                    </ButtonCta>
                                )}
                            />
                        ) : (
                            <ButtonCta
                                onClick={(event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
                                    onFinanceClick(event, "cc-panel");
                                }}
                                iconVariant={CtaIcon.Card}
                            >
                                <BnbLabel label={financeLabelKey} />
                            </ButtonCta>
                        )}
                    </Styles.ButtonGroup>
                )}

            {/* render loader when tyCode is saving */}
            {tyCodeSaving && (
                <PreloaderStyles.PreLoaderWrapper hasBorder hasButtonHeight>
                    <Preloader size={30} />
                </PreloaderStyles.PreLoaderWrapper>
            )}
            {/* render error when saving tyCode failed */}
            {tyCodeSavingFailed && <BnbLabel label="errorSavingConfig" />}

            <ConsumerBasketCtas
                step={step}
                financeOption={financeOption}
                renderFinanceCalculatorAsPrimary={renderFinanceCalculatorAsPrimary}
                tyCodeSaving={tyCodeSaving}
                tyCodeSavingFailed={tyCodeSavingFailed}
            />
        </>
    );
};

export default BasketCtas;
